import { Box, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { invitationStateTranslations } from 'src/features/employees/constants/employee-invitation-status';
import { EmployeeInvitationStatus } from 'src/features/employees/types/enum/employee-invitation-status';
import { HandleChangeFilterValue } from 'src/types/handle-change-filter-value';
import { Filters } from 'src/types/interfaces/filters';
import { toggleFilterItemSelection } from 'src/utils/filters/toggle-filter-item-selection';

interface Props {
  filters: Filters;
  handleChangeFilterValue: HandleChangeFilterValue;
}

export const EmployeesFilterChips = ({
  filters,
  handleChangeFilterValue,
}: Props) => {
  const { t } = useTranslation();

  const renderFilterChips = () =>
    Object.entries(filters)?.map(
      ([filterType, { value: filterValues, operator }]) => {
        if (!filterValues) {
          return null;
        }

        if (Array.isArray(filterValues)) {
          return filterValues?.map(value => {
            switch (filterType) {
              case 'status':
                return (
                  <Chip
                    key={value.toString()}
                    sx={{ mr: 1, mb: 1 }}
                    color="primary"
                    label={
                      <Typography
                        variant="caption"
                        sx={{ textTransform: 'capitalize' }}>
                        {`${t('employees:employees.status')}: ${t(invitationStateTranslations[value as EmployeeInvitationStatus])}`}
                      </Typography>
                    }
                    size="small"
                    onDelete={() => {
                      toggleFilterItemSelection(
                        filterType,
                        value.toString(),
                        false,
                        filters,
                        handleChangeFilterValue,
                        operator,
                      );
                    }}
                  />
                );

              default:
                return (
                  <Chip
                    key={value.toString()}
                    sx={{ mr: 1, mb: 1 }}
                    color="primary"
                    label={
                      <Typography
                        variant="caption"
                        sx={{ textTransform: 'capitalize' }}>
                        {value}
                      </Typography>
                    }
                    size="small"
                    onDelete={() => {
                      toggleFilterItemSelection(
                        filterType,
                        value.toString(),
                        false,
                        filters,
                        handleChangeFilterValue,
                        operator,
                      );
                    }}
                  />
                );
            }
          });
        }
      },
    );

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyItems: 'flex-start',
        flexWrap: 'wrap',
        px: 3,
        pb: 1.5,
      }}>
      {renderFilterChips()}
    </Box>
  );
};
